




































import {Component, Vue} from "vue-property-decorator";
import axios from 'axios';
import {doctorListType, servicesListType} from '@/types'
import {MutationList as modalMutations, MutationList as ModalMutations} from "@/store/modules/modal/mutation-list";

@Component
export default class SearchSection extends Vue {

    private modalNamespace = 'modal/';

    private doctorsList: doctorListType[] = [];
    private servicesList: servicesListType[] = [];

    // variables for separate filtered list. Fetched list is immutable in this case
    private doctorsListFiltered: doctorListType[] = [];
    private servicesListFiltered: servicesListType[] = [];

    // selected parameters to be passed further
    public selectedDoctor = '';
    public selectedService = '';

    //search v-model
    private search = '';

    //show filter variable

    private showFilter = false;

    // custom filters for each list
    doctorsFilterList(value: string) {
        this.doctorsListFiltered = [];
        return this.doctorsList.forEach((item) => {
            if (item.DoctorDisplayName.toLowerCase().indexOf(value.toLowerCase()) > -1) this.doctorsListFiltered.push(item);
        })
    }

    servicesFilterList(value: string) {
        this.servicesListFiltered = [];
        return this.servicesList.forEach((item) => {
            if (item.name.toLowerCase().indexOf(value.toLowerCase()) > -1) this.servicesListFiltered.push(item);
        })
    }

    // submit search based on search query. fetch results

    async submitSearch() {
        this.$store.commit(`${this.modalNamespace}${modalMutations.SELECT_LOADING_MODAL}`, 'search all information');
        await axios.post('https://dev.palmamedical.lv/api/rest/search', this.search)
            .then(response => {
                this.doctorsList = response.data.doctors;
                this.servicesList = response.data.services;
                this.$store.commit(`${this.modalNamespace}${modalMutations.SET_MODAL_VISIBILITY_FALSE}`);
            })
            .catch(e => {
                this.$store.commit(`${this.modalNamespace}${modalMutations.SELECT_MESSAGING_MODAL}`, {
                    header: 'an error happened',
                    message: e
                });
            });
    }

    /*
    * Filter entry point. Receives an event with current HTML node.
    * Launches settimeout to prevent filtering everything on each node update
    * */
    filter(e: any) {
        if (e.currentTarget.value === null) {
            this.doctorsListFiltered = this.doctorsList;
            this.servicesListFiltered = this.servicesList;
            return;
        }
        const value = e.currentTarget.value;
        setTimeout(() => {
            this.doctorsFilterList(value);
            this.servicesFilterList(value);
        }, 500);
        // return debounce(this.filterSelector(value, methodName), 5000);
    }

    // select Item from dropdown and check if possible to go further
    // clears filtered list on the way
    selectItem(index: number, name: string) {
        switch (name) {
            case 'Doctor':
                this.selectedDoctor = this.doctorsListFiltered[index].DoctorDisplayName;
                this.doctorsListFiltered = [];
                this.forward();
                break;
            case 'Service':
                this.selectedService = this.servicesListFiltered[index].name;
                this.servicesListFiltered = [];
                this.forward();
                break;
        }
    }

    forward() {
        if (this.selectedDoctor === '' || this.selectedService === '') return;
        this.$router.push({
            path: '/appointment',
            query: {doctor: this.selectedDoctor, service: this.selectedService}
        });
    }

    showServicesModal() {
        this.$store.commit(`${this.modalNamespace}${ModalMutations.SET_SEARCH_MODAL_VISIBILITY_TRUE}`)
    }

    get allowForward() {
        return this.selectedDoctor || this.selectedService !== '';
    }
}
